module.exports = {
  DELETE: "delete",
  DELETED: "deleted",
  DELETING: "deleting"
};



// WEBPACK FOOTER //
// ./src/js/constants/UserActions.js